module.exports = __webpack_public_path__ + "img/Marathon-Swimming.32197bca.png";